import '../CommonStyles.css';
import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import logo from '../../assets/img/CBRE_logo.svg';
import bg from '../../assets/img/header.jpg';
import * as actionTypes from '../../store/actions/index';

function CoverPageComponent(props) {
  const { data, emails, pdfDownload } = props;
  const deal_ID = '2329'; //production id
  // let deal_ID="2366";//local id

  useEffect(() => {
    if (data && data?.dealId) {
      props.setEmail(data?.dealId);
    }
    // eslint-disable-next-line
  }, [data]);

  return (
    <div className="coverPage">
      <img src={bg} alt="" className="cbreImg" />

      {/* <div className="footer-txt">
         Prepared by: Debi Prasad Mishra - debiprasad.mishra1@cbre.com
        </div> */}
      {data && data?.dealId !== deal_ID && (
        <div className="footer-txt-heading">
          <div style={{ fontSize: 'xx-large', left: '2rem', textAlign: 'left' }}>
            Your Flexperts are -
          </div>
          {emails && emails.length > 0 && (
            <div className="footer-grid">
              {emails.map((email) => (
                <div key={'email_' + email}>{email}</div>
              ))}
            </div>
          )}
        </div>
      )}

      {data && data?.dealId === deal_ID && (
        <div className="footer-txt-heading">
          <div style={{ fontSize: 'xx-large', left: '2rem', textAlign: 'left' }}>Prepared by -</div>
          <div className="footer-grid">
            <div style={{ textAlign: 'left' }}>
              CBRE <br />
              <br />
              John Zanetos C 310 529 8770,
              <br /> John.Zanetos@cbre.com <br />
              <br />
              Kelli Snyder, Kelli.Snyder@cbre.com <br />
              <br />
              Marie Phillips –<br /> marie.phillips@cbre.com <br />
            </div>
          </div>
        </div>
      )}

      <img src={logo} alt="" className="logoImg" />
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    data: state.optRed.data,
    emails: state.comRed.displayMails,
    pdfDownload: state.comRed.pdfDownload,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setEmail: (id) => dispatch(actionTypes.flexpertEmailAction(id, 'CLIENT')),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CoverPageComponent);
